import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import identity from 'lodash/identity';
import parse from 'html-react-parser';

import actions from 'react/api/actions';
import Modal from 'react/components/Modal';

const LogoffAlertModal = ({
  isOpen,
  i18n,
  actualMinutes,
  actualSeconds,
  i18nActions,
  modalActions: {
    closeModal
  }
}) => {
  const btnLabel = Monet.I18n.getResourcesByKey('logoffAlert.button.imHere');
  const modalTitle = i18n.get(
    'eventAuthorizarionModal.label.title',
    'Are you still there?'
  );
  const modalText = Monet.I18n.translateResources(
    'logoffAlert.label',
    {
      actualMinutes,
      actualSeconds
    }
  ) || '';

  useEffect(() => {
    i18nActions.fetchResourcesByKey([
      'login.label.logoffNotice',
      'logoffAlert.label.title',
      'logoffAlert.button.imHere',
    ]);
  }, []);

  const renderDismissButton = () => {
    return (
      <input
        data-testid='dismiss-button'
        type="button"
        value={btnLabel}
        className='default.button.save'
        onClick={closeModal}
      />
    );
  };

  return (
    <div id="logoffAlertModalWrapper">
      <Modal
        isOpen={isOpen && !!modalText}
        closeModalFn={identity}
        title={modalTitle}
        crossAxisBtn={false}
        className="alertLogoffModal"
        containerSelector="logoffAlertModalWrapper"
      >
        {parse(modalText)}
        {renderDismissButton()}
      </Modal>
    </div>
  )
}

LogoffAlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

const mapStateToProps = ({ logoffAlertModal, i18n }) => ({
  isOpen: logoffAlertModal.getIn(['isOpen'], false),
  actualMinutes: logoffAlertModal.getIn(['minutes'], 1),
  actualSeconds: logoffAlertModal.getIn(['seconds'], 0),
  i18n: i18n.get('resources'),
});

const mapActionsToProps = (dispatch) => ({
  i18nActions: bindActionCreators(actions.i18n.actionCreators, dispatch),
  modalActions: bindActionCreators(actions.logoffAlertModal.actionCreators, dispatch)
});

export default connect(mapStateToProps, mapActionsToProps)(LogoffAlertModal)
